/**
 * Graph scope constants for contextual pinning (Story 6).
 * Scope identifies which graph to invoke (e.g. Copilot); NOT agent UUID.
 * Pages inject scope via useChatContextInjector — no URL coupling.
 */
export const SCOPE_UCP = 'ucp';
// Future: SCOPE_CAMPAIGN = 'campaign', SCOPE_DASHBOARD = 'dashboard', etc.
